import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
const SearcherActivitiesContext = /*#__PURE__*/ createContext({});
export const SearcherActivitiesProvider = (props)=>{
    const { value , children  } = props;
    const contextValue = useMemo(()=>({
            props: value
        }), [
        value
    ]);
    return /*#__PURE__*/ _jsx(SearcherActivitiesContext.Provider, {
        value: contextValue,
        children: children
    });
};
const useSearcherActivitiesContext = ()=>useContext(SearcherActivitiesContext);
export const useSearcherActivitiesProps = ()=>useSearcherActivitiesContext().props;

//# sourceMappingURL=index.js.map